import PptxGenJS, { Slide } from "pptxgenjs";
import { DocumentSection } from "../types";
import * as CommonUtils from "../utils";
import * as WordService from "../../../../service/sfp/word-service";
import { MotDto } from "../../../../model";
import { MasterSlide } from "../pptx-configuration/master-slides";
import { Placeholder } from "../pptx-configuration/placeholders";


export async function createGlossaireSection(pptx: PptxGenJS, numbering: number[], gabarit: string): Promise<DocumentSection> {

    const title = "Glossaire";
    let slides: Slide[] = [];

    let words: MotDto[] = [];
    words = await WordService.getWordsByGabarit(gabarit);
    if (words.length == 0) {
        return { slides, title }
    }
    const slide = pptx.addNewSlide(MasterSlide.Chart);
    slide.addText(title, {
        placeholder: Placeholder.Title
    })
    slides.push(slide);

    const Sections = buildGlossaire(words);
    //Gestion du dépassement    
    let currentSlideHeight = pptxConst.TEXT_BASE_Y_POS;

    //Pour chaque Section
    Sections.forEach(section => {
        //On ecrit le titre de la section
        let ret = AddTextToSlide(section.label, slides, "section", currentSlideHeight, pptx);
        slides = ret.slides;
        currentSlideHeight = ret.lastSlideHeight;
        //Pour chaque soussection
        section.SousSections.forEach(sousSection => {
            //On ecrit le titre de la sous section
            let ret = AddTextToSlide(sousSection.label, slides, "soussection", currentSlideHeight, pptx);
            slides = ret.slides;
            currentSlideHeight = ret.lastSlideHeight;
            //Pour chaque mot
            sousSection.Mots.forEach(mot => {
                let ret = AddTextToSlide(mot.Mot + " : " + mot.Definition, slides, "mot", currentSlideHeight, pptx);
                slides = ret.slides;
                currentSlideHeight = ret.lastSlideHeight;
            })
        })
    });

    return { slides, title }
}

function buildGlossaire(words: MotDto[]): Section[] {
    const ret: Section[] = [];
    words.forEach(word => {
        const SectionIdx = ret.findIndex(o => o.label === word.section);
        //Si il n'y a pas de section existante avec le nom de section
        if (SectionIdx == -1) {
            const SectionToAdd: Section = {
                label: word.section,
                SousSections: [{
                    label: word.soussection,
                    Mots: [{ Mot: word.mot, Definition: word.definition }]
                }]
            }
            ret.push(SectionToAdd);
        }
        //Si il y une Section
        else {
            const SousSectionIdx = ret[SectionIdx].SousSections.findIndex(o => o.label == word.soussection)
            //Si il n'y a pas de Sous-section existante qui correspond au mot
            if (SousSectionIdx == -1) {
                const SousSectionToAdd: SousSection = {
                    label: word.soussection,
                    Mots: [{ Mot: word.mot, Definition: word.definition }]
                }
                ret[SectionIdx].SousSections.push(SousSectionToAdd);
            }
            //Si il y a une Sous-Section
            else {
                ret[SectionIdx].SousSections[SousSectionIdx].Mots.push({ Mot: word.mot, Definition: word.definition });
            }
        }
    })
    return ret;
}

function AddTextToSlide(text: string, slides: Slide[], type: string, currentSlideHeight: number, pptx: PptxGenJS): SlidesReturn {
    let outSlideHeight = currentSlideHeight;
    switch (type) {

        case "section":
            if (outSlideHeight + pptxConst.SECTION_HEIGHT > pptxConst.SLIDE_HEIGHT) {
                slides.push(pptx.addNewSlide(MasterSlide.Chart));
                outSlideHeight = pptxConst.TEXT_BASE_Y_POS;
            }
            slides[slides.length - 1].addText(text,
                {
                    x: pptxConst.SECTION_X_POS, y: outSlideHeight, w: "90%", h: pptxConst.SECTION_HEIGHT,
                    valign: "top", fontSize: 24, color: "000000", underline: true, bold: true, breakLine: true, lineSpacing: 30
                }
            )
            outSlideHeight += pptxConst.SECTION_HEIGHT;
            break;

        case "soussection":
            if (outSlideHeight + pptxConst.SOUS_SECTION_HEIGHT > pptxConst.SLIDE_HEIGHT) {
                slides.push(pptx.addNewSlide(MasterSlide.Chart));
                outSlideHeight = pptxConst.TEXT_BASE_Y_POS;
            }
            slides[slides.length - 1].addText(text,
                {
                    x: pptxConst.SOUS_SECTION_X_POS, y: outSlideHeight, w: "90%", h: pptxConst.SOUS_SECTION_HEIGHT,
                    valign: "top", fontSize: 18, color: "000000", underline: true, bold: true, breakLine: true, lineSpacing: 24
                }
            )
            outSlideHeight += pptxConst.SOUS_SECTION_HEIGHT;
            break;

        case "mot":
            if (outSlideHeight + pptxConst.MOT_DEF_HEIGHT > pptxConst.SLIDE_HEIGHT) {
                slides.push(pptx.addNewSlide(MasterSlide.Chart));
                outSlideHeight = pptxConst.TEXT_BASE_Y_POS;
            }
            slides[slides.length - 1].addText(text,
                {
                    x: pptxConst.MOT_DEF_X_POS, y: outSlideHeight, w: "90%", h: pptxConst.MOT_DEF_HEIGHT,
                    valign: "top", fontSize: 14, color: "000000", lineSpacing: 15
                }
            )
            outSlideHeight += pptxConst.MOT_DEF_HEIGHT;
            break;

        default:
            break;
    }

    return { slides: slides, lastSlideHeight: outSlideHeight };
}

enum pptxConst {
    SLIDE_HEIGHT = 7.25,
    TEXT_BASE_Y_POS = 1.45,

    SECTION_X_POS = 1,
    SOUS_SECTION_X_POS = 1.2,
    MOT_DEF_X_POS = 1.4,

    SECTION_HEIGHT = 0.5,
    SOUS_SECTION_HEIGHT = 0.5,
    MOT_DEF_HEIGHT = 0.5,
}

class SlidesReturn {
    slides: Slide[];
    lastSlideHeight: number;
}

class Section {
    SousSections: SousSection[];
    label: string;
}

class SousSection {
    Mots: Mot[];
    label: string;
}

class Mot {
    Mot: string;
    Definition: string;
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/glossaryGenerator/index.tsx